var PromState;
(function (PromState) {
  PromState["Fulfilled"] = "fulfilled";
  PromState["Rejected"] = "rejected";
})(PromState || (PromState = {}));
export default function allSettled(promises) {
  if (!Array.isArray(promises)) {
    throw new TypeError('Must supply an array of Promises');
  }
  const wrappedPromises = promises.map(promise => Promise.resolve(promise).then(val => ({
    state: 'fulfilled',
    value: val
  }), err => ({
    state: 'rejected',
    reason: err
  })));
  const res = Promise.all(wrappedPromises);
  return res;
}